import { createSelector } from 'reselect';
import { isNull, isUndefined, omitBy, pick } from 'lodash/fp';
import { PRODUCT_TYPE, RELATIONSHIP } from '@ahmdigital/constants';

import { INCOME_TIER_NONE } from '../../constants';
import getMemberAge from '../../../../utils/get-member-age';
import selectCustomer from '../../../../selectors/select-customer';

export const getNormalizedProductType = (productType: string | undefined) => {
  if (isUndefined(productType)) {
    return PRODUCT_TYPE.EXTRAS;
  }

  if (productType === PRODUCT_TYPE.COMBINED) {
    return PRODUCT_TYPE.PACKAGE;
  }

  return productType;
};

export default createSelector(selectCustomer, (customer) =>
  omitBy((value) => isNull(value) || isUndefined(value), {
    ...pick(
      ['frequency', 'hospitalExcess', 'incomeTier', 'incomeType', 'productType', 'rebate', 'scale', 'state'],
      customer,
    ),
    age: getMemberAge({ customer, relationship: RELATIONSHIP.CLIENT }) || '',
    incomeTier: customer.rebate === false ? INCOME_TIER_NONE : customer.incomeTier,
    partnerAge: getMemberAge({ customer, relationship: RELATIONSHIP.SPOUSE }) || '',
    productType: getNormalizedProductType(customer.productType),
  }),
);
